/**
 * The lookup's row for a stored station text (SA-1056): the entry for `stationCode(text)`, else
 * undefined (free text, no row for the code, or no map yet). Its own file because `Station.tsx`
 * may export components only (react-refresh).
 */
import type { Airport } from '@/types/airports'
import { stationCode } from './stationCode'

export function airportFor(byCode: Record<string, Airport> | undefined, text: string | null | undefined): Airport | undefined {
  const code = stationCode(text)
  return code ? byCode?.[code] : undefined
}
